 import { useHistory, useLocation } from "react-router-dom";
import Cookies from "js-cookie";

const VideosIntegrated = ({language , token}) => {
  const history = useHistory()
  const { state } = useLocation();
  const iframePathUrl = state?.id 
  ?`/video/${state.filename}/${state.id}/edit`
  :"/medias"
    const newVideosIframe = "https:" +
    window.process.env.URL_Media +
    iframePathUrl
    +  "?lang=" + language + "&token=" +
      token

      window.addEventListener("message", function (event) {
        initHelp(event.data)       
    });     

    function initHelp(type ) {
		if (type && typeof type.info !== typeof undefined &&  typeof type.value !== typeof undefined ) {		
				if (type.info === "statsPerVideo") {
                     history.push(`/media/video/${type.value.id}`);                 
				}			
		}
	}
const GridTaille = Cookies.get('GridTaille')
const size = (GridTaille!==null && typeof GridTaille !== typeof undefined) ? `&size=${GridTaille}` : ""

    return (
      <iframe
        id="iframe_videos_display"
        src={`${newVideosIframe}${size}`}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default VideosIntegrated